"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageAggregationInterval = void 0;
exports.UsageAggregationInterval = {
    Hour: "hour",
    Day: "day",
    Week: "week",
    Month: "month",
    Cumulative: "cumulative",
};
